import { PageHeader } from '@app/components/layout/page/components/page-header';
import ProductTable from '@app/components/tables/product-table/product-table';
import { Icons } from '@shared/components/content/icons';
import { Button } from '@shared/components/ui/button';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../auth/use-auth';
import Page from '../../components/layout/page/page';

import useHandleCreateNewProductAction from '@app/hooks/use-create-new-product-action';
import Alert from '@shared/components/alert';
import { pcfRoutes } from '../pcf-routes';

const ProductsPage: React.FC = () => {
  const { handleCreateNewProductAction, UpsellDialogComponent } =
    useHandleCreateNewProductAction();

  const { user } = useAuth();
  const navigate = useNavigate();

  const { organizationProductLimit, numberOfProducts } = user!;

  return (
    <Page name="Products">
      <PageHeader
        name="Products"
        toolbar={
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              onClick={() => navigate(pcfRoutes.PRODUCTS_QUICK_IMPORT)}
              data-testid="open-quick-import"
            >
              <Icons.import className="mr-2 size-4" />
              Quick Import
            </Button>
            <Button onClick={handleCreateNewProductAction}>Create</Button>
          </div>
        }
      />

      {UpsellDialogComponent}

      {organizationProductLimit &&
        organizationProductLimit < numberOfProducts! && (
          <Alert variant="warning" title="Product limit exceeded">
            You have exceeded your product limit
          </Alert>
        )}

      {
        // if product count is more than 80% of the limit, show warning
        organizationProductLimit &&
          organizationProductLimit * 0.8 <= numberOfProducts! &&
          organizationProductLimit > numberOfProducts! && (
            <Alert variant="warning" title="Nearing product limit">
              You are nearing your limit of {organizationProductLimit} products
            </Alert>
          )
      }
      {
        // if product count is more than 100% of the limit, show error
        organizationProductLimit &&
          organizationProductLimit === numberOfProducts && (
            <Alert variant="warning" title="Product limit reached">
              You have reached your product limit
            </Alert>
          )
      }
      <div className="mt-5 flex w-full">
        <ProductTable type="card" />
      </div>
    </Page>
  );
};

export default ProductsPage;
